const scannerError = {
  methods: {
    getScannerErrorHint(errno, type) {
      const error = `${errno}`; // make it a string anyway
      if (error === '40003') {
        if (type === 'mobile') return this.$t('mobileScan.upload_error');

        return this.$t('scan.scanner_not_activated');
      }
      if (error === '40004') return this.$t('scan.scanner_error_need_reset');
      if (error === '40302') return this.$t('scan.scanner_check_network');
      if (error === '40303') return this.$t('scan.scanner_occupied');
      if (error === '40305') return this.$t('mobileScan.no_balance');
      if (error === '40306') return this.$t('mobileScan.scan_limit_reached');

      return this.$t('scan.scanner_error_generic');
    },
  },
};

export default scannerError;
